export default __webpack_public_path__ + "static/media/icon-notificacao.35784b68.svg";